import { _, AbortToken, HttpError, HttpMethod } from "libs";
/// <reference types="stripe-v3" />
import { push } from "connected-react-router";

import {
	AdData,
	APIResponse,
	Card,
	Championship,
	ChampionshipInvitePayload,
	ChampionshipOptInContext,
	Club,
	ClubMembershipData,
	Court,
	Flag,
	FlashMessage,
	FlashMessageType,
	Friend,
	GetChampionshipsResponse,
	ICustomWindow,
	IPAPIResponse,
	LeaderboardData,
	LeaderboardQueryParams,
	LeaderboardResponse,
	Location,
	Match,
	MembershipsResponse,
	NewsletterData,
	NewsletterSettings,
	OfficialRating,
	PaymentMethod,
	Player,
	Profile,
	ProfileValidationFlag,
	Reservation,
	ReservationContext,
	Slot,
	SlotsData,
	SocialFindResponse,
	SubscriptionPlans,
	SubscriptionPlansData,
	TokenResponse,
	User,
	WaitingReservation,
	Weather,
} from "../types";
import { ReservationState } from "../reducers/reservation";
import { Dispatch } from "redux";
import { getRefreshToken, hasAuthCookies, removeNewAppForceCookie, removeTokens, setAccessToken } from "../libs/tokens";
import { getCookie, hasCookie, setCookie } from "../libs/cookies";
import { getBookingError } from "../libs/bookingErrors";
import { postWidgetMessage } from "../libs/widgetMessaging";
import processError, { extractDurations } from "./helpers";
import { RootState } from "../reducers";
import { getShortLang } from "../libs/detectLanguage";
import { createAppApiClient, federationBaseURL } from "../libs/createHttp";
import decodeJwtToken from "../libs/decodeJwtToken";
import H from "history";
import { call } from "ramda";
import { getAnalytics, logEvent } from "firebase/analytics";
import { PaymentIntentResult, Stripe } from "@stripe/stripe-js";

declare function loadLang(lang: string): void;

export const LOGGING_OUT = "LOGGING_OUT";
export const AUTHENTICATED = "AUTHENTICATED";
export const UNAUTHENTICATED = "UNAUTHENTICATED";
export const AUTHENTICATION_ERROR = "AUTHENTICATION_ERROR";
export const PROFILE_UPDATED = "PROFILE_UPDATED";

export const ADD_FLASH_MESSAGE = "ADD_FLASH_MESSAGE";
export const REMOVE_FLASH_MESSAGE = "REMOVE_FLASH_MESSAGE";

export const LOAD_FRIENDS = "LOAD_FRIENDS";
export const CHANGE_FRIEND_STATUS = "CHANGE_FRIEND_STATUS";

export const ADD_FAVORITE = "ADD_FAVORITE";
export const LOAD_FAVORITES = "LOAD_FAVORITES";

export const LOAD_SUPPORTED_COUNTRIES = "LOAD_SUPPORTED_COUNTRIES";
export const LOAD_SUPPORTED_LANGUAGES = "LOAD_SUPPORTED_LANGUAGES";
export const LOAD_SUPPORTED_SPORTS = "LOAD_SUPPORTED_SPORTS";
export const LOAD_RATINGS = "LOAD_RATINGS";

export const LOAD_DASHBOARD = "LOAD_DASHBOARD";
export const SEARCH_CLUB = "SEARCH_CLUB";
export const LOAD_CLUB = "LOAD_CLUB";
export const LOAD_CLUB_WEATHER = "LOAD_CLUB_WEATHER";
export const LOAD_CLUB_FAIL = "LOAD_CLUB_FAIL";

export const MAP_CENTER_CHANGED = "MAP_CENTER_CHANGED";
export const SEARCH_SLOTS = "SEARCH_SLOTS";

export const GET_RESERVATION_CONTEXT = "GET_RESERVATION_CONTEXT";
export const CLEAR_RESERVATION_CONTEXT = "CLEAR_RESERVATION_CONTEXT";
export const ADD_CARD = "ADD_CARD";
export const EDIT_CARD = "EDIT_CARD";
export const REMOVE_CARD = "REMOVE_CARD";
export const LOAD_CARDS = "LOAD_CARDS";
export const SELECT_PAYMENT_METHOD = "SELECT_PAYMENT_METHOD";
export const SELECT_CARD = "SELECT_CARD";
export const SELECT_NETWORK = "SELECT_NETWORK";
export const RESERVATION_RESULT = "RESERVATION_RESULT";
export const RESERVATION_VALIDATE = "RESERVATION_VALIDATE";

export const ADD_PARTNER_TO_RESERVATION = "ADD_PARTNER_TO_RESERVATION";
export const REMOVE_PARTNER_FROM_RESERVATION = "REMOVE_PARTNER_FROM_RESERVATION";
export const SHOW_UNAVAILABILITY = "SHOW_UNAVAILABILITY";
export const RESERVATION_CONTEXT_PRELOAD = "RESERVATION_CONTEXT_PRELOAD";
export const CANCEL_RESERVATION = "CANCEL_RESERVATION";
export const ADD_RESERVATION_ERROR = "ADD_RESERVATION_ERROR";
export const SET_FEDERATION_USERID = "SET_FEDERATION_USERID";

export const EDIT_RESERVATION = "EDIT_RESERVATION";
export const CANCEL_EDIT_RESERVATION = "CANCEL_EDIT_RESERVATION";

export const FAVORITE_CLUB = "FAVORITE_CLUB";
export const UNFAVORITE_CLUB = "UNFAVORITE_CLUB";
export const REQUEST_CLUB_MEMBERSHIP = "REQUEST_CLUB_MEMBERSHIP";
export const CANCEL_CLUB_MEMBERSHIP = "CANCEL_CLUB_MEMBERSHIP";

export const LOAD_SEASON_STATS = "LOAD_SEASON_STATS";

export const ADD_LOCATION = "ADD_LOCATION";
export const ADD_LOCATION_ERROR = "ADD_LOCATION_ERROR";
export const UPDATE_LOCATION_PLAYERS_COUNT = "UPDATE_LOCATION_PLAYERS_COUNT";
export const UPDATE_FAVORITE_CLUB_PLAYERS_COUNT = "UPDATE_FAVORITE_CLUB_PLAYERS_COUNT";
export const UPDATE_CURRENT_LOCATION_COORDINATES = "UPDATE_CURRENT_LOCATION_COORDINATES";

export const LOAD_MATCHES = "LOAD_MATCHES";
export const OPEN_PLAYER_POPUP = "OPEN_PLAYER_POPUP";
export const OPEN_PLAYER_CHAMPIONSHIP_POPUP = "OPEN_PLAYER_CHAMPIONSHIP_POPUP";

export const OPEN_CHAMPIONSHIP_LEADERBOARD_POPUP = "OPEN_CHAMPIONSHIP_LEADERBOARD_POPUP";
export const OPEN_CHALLENGE_LEADERBOARD_POPUP = "OPEN_CHALLENGE_LEADERBOARD_POPUP";
export const OPEN_OFFICIAL_RATING_POPUP = "OPEN_OFFICIAL_RATING_POPUP";
export const OPEN_INVITE_POPUP = "OPEN_INVITE_POPUP";
export const CLOSE_PLAYER_POPUP = "CLOSE_PLAYER_POPUP";
export const CLOSE_PLAYER_CHAMPIONSHIP_POPUP = "CLOSE_PLAYER_CHAMPIONSHIP_POPUP";

export const CLOSE_CHAMPIONSHIP_LEADERBOARD_POPUP = "CLOSE_CHAMPIONSHIP_LEADERBOARD_POPUP";
export const CLOSE_CHALLENGE_LEADERBOARD_POPUP = "CLOSE_CHALLENGE_LEADERBOARD_POPUP";
export const CLOSE_VALIDATE_PROFILE_POPUP = "CLOSE_VALIDATE_PROFILE_POPUP";
export const CLOSE_OFFICIAL_RATING_POPUP = "CLOSE_OFFICIAL_RATING_POPUP";
export const CLOSE_INVITE_POPUP = "CLOSE_INVITE_POPUP";

export const LOAD_ADVERTS = "LOAD_ADVERTS";
export const SAVE_BACK_LINK = "SAVE_BACK_LINK";
export const RESET_BACK_LINK = "RESET_BACK_LINK";

export const LOAD_MY_CHAMPIONSHIPS = "LOAD_MY_CHAMPIONSHIPS";
export const LOAD_LEADERBOARD_FIRST_PAGE = "LOAD_LEADERBOARD_FIRST_PAGE";

export const TIMEZONE_FETCHED = "TIMEZONE_FETCHED";
export const IP_LOCATION_FETCHED = "IP_LOCATION_FETCHED";

export type GetState = () => RootState;

const http = createAppApiClient();

let slotsRequestsAbortController: AbortController;
let playersRequestsAbortController: AbortController;
let clubsRequestsAbortController: AbortController;
let playerProfilesRequestsAbortController: AbortController;

let id = 0;
export function flashMessage(
	text: string,
	type = FlashMessageType.SUCCESS,
	duration = 5
): { type: typeof ADD_FLASH_MESSAGE; message: FlashMessage } {
	id++;
	window.setTimeout(() => {
		// @ts-ignore
		window.store.dispatch(removeFlash(id));
	}, duration * 1000);
	return {
		type: ADD_FLASH_MESSAGE,
		message: {
			id,
			text,
			type,
			duration,
		},
	};
}

export function flash(text: string, type = FlashMessageType.SUCCESS, duration = 5): void {
	// @ts-ignore
	window.store.dispatch(flashMessage(text, type, duration));
}

export function flashError(text: string, duration = 5): void {
	// @ts-ignore
	window.store.dispatch(flashMessage(text, FlashMessageType.ERROR, duration));
}

function removeFlash(id: number): { type: typeof REMOVE_FLASH_MESSAGE; id: number } {
	return {
		type: REMOVE_FLASH_MESSAGE,
		id,
	};
}

export const logoutUser = (dispatch: Dispatch, location = null as string): void => {
	removeTokens();
	logoutOAuth().then(
		res => {
			dispatch({ type: LOGGING_OUT });
			dispatch({ type: UNAUTHENTICATED });
			if (location) {
				dispatch(push(location));
			} else {
				if (!process.env.REACT_APP_AFTER_LOGOUT_REDIRECT_URI) {
					dispatch(push("/login"));
				} else {
					window.location.href = process.env.REACT_APP_AFTER_LOGOUT_REDIRECT_URI;
				}
			}
		},
		rej => {
			console.log(rej);
		}
	);
};

export const logoutOAuth = (): Promise<Response> => {
	return fetch(process.env.REACT_APP_TOKEN_LOGOUT_URL, {
		method: HttpMethod.POST,
		mode: "cors",
		redirect: "follow",
		headers: {
			"Content-Type": "application/json;charset=utf-8",
		},
		credentials: "include",
	});
};

export function setFederationUserId(federationUserId?: string) {
	return async (dispatch: Dispatch): Promise<void> => {
		dispatch({
			type: SET_FEDERATION_USERID,
			federationUserId,
		});
	};
}

export function register(
	firstName: string,
	lastName: string,
	email: string,
	password: string,
	locale: string,
	destination = "/"
) {
	return async (dispatch: Dispatch): Promise<void> => {
		try {
			const res = await http.post<APIResponse<TokenResponse>>(
				"/auth/register",
				{
					firstName,
					lastName,
					email,
					password,
					locale,
				},
				{ withEvents: false },
				{
					//credentials: "include",
				}
			);

			const data = res.data;

			dispatch({
				type: AUTHENTICATED,
				accessToken: data.access_token,
			});
			setAccessToken(data.access_token);

			const decoded = decodeJwtToken(data.access_token);
			const { userId } = decoded;

			const profileRes = await http.get<APIResponse<Profile>>(`/player/profile/${userId}`);
			const profile = profileRes.data;

			dispatch({
				type: PROFILE_UPDATED,
				profile,
			});

			let oldLang;
			if (hasCookie("lang")) {
				oldLang = getCookie("lang");
			}

			setCookie("lang", profile.language, 15);

			if (oldLang !== profile.language) {
				loadLang(profile.language);
			}

			dispatch(push(destination));
		} catch (error) {
			processError(dispatch, error);
		}
	};
}

if (window.hasOwnProperty("Cypress")) {
	//@ts-ignore
	window.login = (username: string, password: string) => login(username, password)(window.store.dispatch);
}

function setLanguage(profile: Profile): void {
	let oldLang: string;
	if (hasCookie("lang")) {
		oldLang = getCookie("lang");
	}

	let lang = profile.language;
	if (!lang) {
		lang = getShortLang();
	}
	setCookie("lang", lang, 15);

	if (oldLang !== lang) {
		loadLang(lang);
	}
}

export function login(username: string, password: string, destination = "/") {
	return async (dispatch: Dispatch, getState: GetState): Promise<{ error: boolean }> => {
		const authRes = await http.post<TokenResponse>(
			process.env.REACT_APP_TOKEN_REFRESH_URL,
			{
				username,
				password,
				grant_type: "password",
				client_id: process.env.REACT_APP_CLIENT_ID,
				client_secret: process.env.REACT_APP_CLIENT_SECRET,
			},
			{ withEvents: false },
			{
				//credentials: "include",
			}
		);

		setAccessToken(authRes.access_token);

		const decoded = decodeJwtToken(authRes.access_token);
		const { userId } = decoded;

		const res = await http.get<APIResponse<Profile>>(`/player/profile/${userId}`);

		const profile = res.data;

		dispatch({
			type: AUTHENTICATED,
			accessToken: authRes.access_token,
		});

		dispatch({
			type: PROFILE_UPDATED,
			profile,
		});

		setLanguage(profile);

		detectCountryByIp();

		dispatch(push(destination));

		return { error: false };
	};
}

let loginCodeUsed = null;
export function codeLogin(code: string, redirect?: string) {
	return async (dispatch: Dispatch, getState: GetState): Promise<{ error: any }> => {
		if (loginCodeUsed === code) {
			dispatch(push("/login"));
			return { error: false };
		}

		const backlink = getState().auth.backlink;

		loginCodeUsed = code;

		try {
			const authRes = await http.post<TokenResponse>(
				process.env.REACT_APP_TOKEN_REFRESH_URL,
				{
					code,
					grant_type: "authorization_code",
					client_id: process.env.REACT_APP_CLIENT_ID,
					client_secret: process.env.REACT_APP_CLIENT_SECRET,
					redirect_uri: process.env.REACT_APP_AUTH_REDIRECT_URI,
				},
				{ withEvents: false },
				{
					credentials: "include",
				}
			);

			removeTokens();
			setAccessToken(authRes.access_token);

			const decoded = decodeJwtToken(authRes.access_token);
			const { userId } = decoded;

			const res = await http.get<APIResponse<Profile>>(`/player/profile/${userId}`);
			const profile = res.data;

			dispatch({
				type: AUTHENTICATED,
				accessToken: authRes.access_token,
			});

			dispatch({
				type: PROFILE_UPDATED,
				profile,
			});

			setLanguage(profile);

			detectCountryByIp();

			let location = "/";

			if (redirect) {
				location = redirect;
			} else if (backlink) {
				location = backlink.pathname;
				if (backlink.search) {
					location = `${location}?${backlink.search}`;
				}
			}

			dispatch(push(location));

			return { error: false };
		} catch (error) {
			logoutUser(dispatch);
			return { error };
		}
	};
}

export function refreshMyProfile() {
	return async (dispatch: Dispatch, getState: GetState): Promise<void> => {
		try {
			const { auth } = getState();
			const res = await http.get<APIResponse<Profile>>(`/player/profile/${auth.userId}`);
			const profile = res.data;

			dispatch({
				type: PROFILE_UPDATED,
				profile,
			});
		} catch (error) {
			processError(dispatch, error);
		}
	};
}

export function socialLogin(type: string, token: string, destination = "/") {
	return async (dispatch: Dispatch): Promise<void> => {
		try {
			const res = await http.post<TokenResponse>(
				process.env.REACT_APP_TOKEN_REFRESH_URL,
				{
					token,
					type,
					grant_type: "http://gotcourts.com/grants/social",
					client_id: process.env.REACT_APP_CLIENT_ID,
					client_secret: process.env.REACT_APP_CLIENT_SECRET,
				},
				null,
				{ credentials: "include" }
			);

			dispatch({
				type: AUTHENTICATED,
				accessToken: res.access_token,
			});

			setAccessToken(res.access_token);
			dispatch(push(destination));
		} catch (error) {
			processError(dispatch, error);
		}
	};
}

export function logout(location = null as string) {
	return async (dispatch: Dispatch): Promise<void> => {
		try {
			logoutUser(dispatch, location);
		} catch (error) {
			processError(dispatch, error);
		}
	};
}

export function forceLogout(location = null as string) {
	const dispatch = myWindow.store.dispatch;
	try {
		logoutUser(dispatch, location);
	} catch (error) {
		processError(dispatch, error);
	}
}

export async function getMatches({
	pageCurrent = 0,
	pageLimit = 10,
	playerId = null,
	championshipId = null,
}: { pageCurrent?: number; pageLimit?: number; playerId?: string; championshipId?: string } = {}): Promise<Match[]> {
	const params = playerId && championshipId ? { playerId, championshipId } : {};
	const res = await http.get<APIResponse<Match[]>>(
		"/matches",
		Object.assign(
			{
				pageCurrent,
				pageLimit,
			},
			params
		)
	);

	return res.data;
}

export function loadFriendsWithoutDispatch({
	pageCurrent = 0,
	pageLimit = 20,
	clubId = null,
	courtId = null,
	timestamp = null,
	term = null,
}: {
	pageCurrent?: number;
	pageLimit?: number;
	clubId?: string;
	courtId?: string;
	timestamp?: number;
	term?: string;
} = {}): Promise<APIResponse<Friend[]>> {
	return http.get<APIResponse<Friend[]>>("/social/friends", {
		pageCurrent,
		pageLimit,
		clubId,
		courtId,
		timestamp,
		term,
	});
}

export function loadFriends({
	pageCurrent = 0,
	pageLimit = 20,
	clubId = null,
	courtId = null,
	timestamp = null,
	term = null,
	forceLoading = false,
}: {
	pageCurrent?: number;
	pageLimit?: number;
	clubId?: string;
	courtId?: string;
	timestamp?: number;
	term?: string;
	forceLoading?: boolean;
} = {}) {
	return async (dispatch: Dispatch, getState: GetState): Promise<Friend[]> => {
		try {
			const friends = getState().social.friends;

			if (true === forceLoading || friends.length === 0) {
				const res = await loadFriendsWithoutDispatch({
					pageCurrent,
					pageLimit,
					clubId,
					courtId,
					timestamp,
					term,
				});

				if (friends.length === 0) {
					dispatch({ type: LOAD_FRIENDS, friends: res.data });
				}

				return res.data;
			}

			return friends as Friend[];
		} catch (error) {
			processError(dispatch, error);
		}
	};
}

export function acceptFriendRequest(uuid: string) {
	return async (dispatch: Dispatch): Promise<void> => {
		try {
			const res = await http.post<APIResponse<any>>(`/social/friend/accept/${uuid}`);

			dispatch({
				type: CHANGE_FRIEND_STATUS,
				friend: res.data,
			});
		} catch (error) {
			processError(dispatch, error);
		}
	};
}

export function rejectFriendRequest(uuid: string) {
	return async (dispatch: Dispatch): Promise<void> => {
		try {
			const res = await http.delete<APIResponse<any>>(`/social/friend/reject/${uuid}`);

			dispatch({
				type: CHANGE_FRIEND_STATUS,
				friend: res.data,
			});
		} catch (error) {
			processError(dispatch, error);
		}
	};
}

export function loadFavorites(pageCurrent = 0, pageLimit = 20, force = false) {
	return async (dispatch: Dispatch, getState: GetState): Promise<Club[]> => {
		try {
			let clubs = await getState().clubs.favorites;
			if (clubs === null || force) {
				const res = await http.get<APIResponse<{ clubs: Club[] }>>("/favorites", {
					pageCurrent,
					pageLimit,
				});
				clubs = res.data.clubs;
			}

			dispatch({
				type: LOAD_FAVORITES,
				favorites: clubs,
			});
			return clubs;
		} catch (error) {
			processError(dispatch, error);
		}
	};
}

export function loadSupportedCountries() {
	return async (dispatch: Dispatch): Promise<void> => {
		try {
			const res = await http.get<APIResponse<any>>("/utilities/supported/countries");
			dispatch({
				type: LOAD_SUPPORTED_COUNTRIES,
				countries: res.data,
			});
		} catch (error) {
			processError(dispatch, error);
		}
	};
}

export function loadSupportedLanguages() {
	return async (dispatch: Dispatch): Promise<void> => {
		try {
			const res = await http.get<APIResponse<any>>("/utilities/supported/languages");
			dispatch({
				type: LOAD_SUPPORTED_LANGUAGES,
				languages: res.data,
			});
		} catch (error) {
			processError(dispatch, error);
		}
	};
}

export function loadSupportedSports() {
	return async (dispatch: Dispatch): Promise<void> => {
		try {
			const res = await http.get<APIResponse<any>>("/utilities/supported/sports");
			dispatch({
				type: LOAD_SUPPORTED_SPORTS,
				sports: res.data,
			});
		} catch (error) {
			processError(dispatch, error);
		}
	};
}

export function loadRatings() {
	return async (dispatch: Dispatch): Promise<void> => {
		try {
			const res = await http.get<APIResponse<any>>("/player/ratings");
			dispatch({
				type: LOAD_RATINGS,
				ratings: res.data,
			});
		} catch (error) {
			processError(dispatch, error);
		}
	};
}

export function loadDashboard() {
	return async (dispatch: Dispatch): Promise<void> => {
		try {
			const res = await http.get<APIResponse<any>>("/club/search/dashboard");
			dispatch({
				type: LOAD_DASHBOARD,
				data: res.data,
			});
		} catch (error) {
			processError(dispatch, error);
		}
	};
}

function changeLanguage(language: string): boolean {
	let changed = false;
	let oldLang: string;
	if (hasCookie("lang")) {
		oldLang = getCookie("lang");
	}

	setCookie("lang", language, 15);

	if (oldLang !== language) {
		loadLang(language);
		changed = true;
		//myWindow.translator.setLocale(language);
		myWindow.location.reload();
	}

	return changed;
}

export function updateProfile(values: object) {
	const blacklist = ["showOnboarding", "flags", "favorites"];
	return async (dispatch: Dispatch, getState: GetState): Promise<void> => {
		const filtered = Object.fromEntries(
			Object.entries(values)

				.filter(([key, val]) => {
					return !blacklist.includes(key);
				})
				.map(([key, val]) => {
					return [key, val];
				})
		);

		if (filtered.rating?.officialRating) {
			delete filtered.rating.officialRating;
		}

		const res = await http.put<APIResponse<Profile>>("/player/profile", filtered);
		const profile = res.data;
		if (filtered.dispatchProfileUpdated !== false) {
			dispatch({
				type: PROFILE_UPDATED,
				profile,
			});
		}

		changeLanguage(profile.language);
	};
}

export function mapCenterChanged(center) {
	return {
		type: MAP_CENTER_CHANGED,
		center,
	};
}

export async function searchSlots(params) {
	try {
		if (slotsRequestsAbortController) {
			slotsRequestsAbortController.abort();
		}
		const res = await http.get<APIResponse<any>>("/slots/search", params, {
			abortToken: new AbortToken((ac: AbortController) => {
				slotsRequestsAbortController = ac;
			}),
		});
		return res.data.searchResults;
	} catch (error) {
		//processError(dispatch, error);
	}
}

export async function searchChatPartners(term, page = 0, limit = 20): Promise<User[]> {
	try {
		if (playersRequestsAbortController) {
			playersRequestsAbortController.abort();
		}
		const res = await http.get<APIResponse<any>>(
			"/player/profiles",
			{
				term,
				pageCurrent: page,
				pageLimit: limit,
			},

			{
				abortToken: new AbortToken(ac => {
					playersRequestsAbortController = ac;
				}),
			}
		);
		return new Promise(resolve => resolve(res.data));
	} catch (error) {
		console.log(error);
	}
}

export async function searchClubs(term, pageCurrent = 0, pageLimit = 10) {
	let result = [];
	try {
		if (clubsRequestsAbortController) {
			clubsRequestsAbortController.abort();
		}

		const res = await http.get<APIResponse<any>>(
			"/club/autocomplete",
			{
				term,
				pageCurrent,
				pageLimit,
			},
			{
				abortToken: new AbortToken(ac => {
					clubsRequestsAbortController = ac;
				}),
			}
		);
		result = res.data;
	} catch (error) {
		console.log(error);
	}

	return result;
}

export function searchClub(term, pageCurrent = 0, pageLimit = 10) {
	return async (dispatch: Dispatch): Promise<void> => {
		try {
			const res = await http.get<APIResponse<any>>("/club/autocomplete");
			dispatch({
				type: SEARCH_CLUB,
				clubs: res.data,
			});
		} catch (error) {
			processError(dispatch, error);
		}
	};
}

export function addFavoriteClub(uuid: string) {
	return async (dispatch: Dispatch): Promise<any> => {
		try {
			const res = await http.post<APIResponse<any>>(`/favorite/club/${uuid}`);
			dispatch({
				type: ADD_FAVORITE,
			});
			return res;
		} catch (error) {
			processError(dispatch, error);
		}
	};
}

export function finishOnboarding() {
	return async (dispatch: Dispatch, getState: GetState): Promise<void> => {
		const profile = await updateFlag(Flag.ShowOnboarding, 0);

		dispatch({
			type: PROFILE_UPDATED,
			profile,
		});

		await loadFavorites(0, 20, true)(dispatch, getState);

		dispatch(push("/"));
	};
}

export async function updateFlag(flag: Flag, value: 0 | 1): Promise<Profile> {
	try {
		const res = await http.put<APIResponse<Profile>>(`/player/profile/flag/${flag}/${value}`);
		return res.data;
	} catch (error) {
		console.log(error);
		//processError(dispatch, error);
	}
}

export function redirect(path: string) {
	return (dispatch: Dispatch, getState: GetState): void => {
		dispatch(push(path, getState()));
	};
}

export function saveBackLink(backLink: H.Location) {
	return (dispatch: Dispatch, getState: GetState): void => {
		dispatch({
			type: SAVE_BACK_LINK,
			backLink,
		});
	};
}

export function resetBackLink() {
	return (dispatch: Dispatch, getState: GetState): void => {
		dispatch({
			type: RESET_BACK_LINK,
		});
	};
}

export function loadClub(uuid: string) {
	return async (dispatch: Dispatch, getState: GetState): Promise<Club> => {
		try {
			const club = await getClub(uuid);
			dispatch({
				type: LOAD_CLUB,
				club,
			});
			return club;
		} catch (error) {
			dispatch({
				type: LOAD_CLUB_FAIL,
				error,
			});
			processError(dispatch, error);
		}
	};
}

export async function getClub(uuid: string): Promise<Club> {
	try {
		const timestamp = Math.floor(Date.now() / 1000);
		const res = await http.get<APIResponse<Club>>(`/club/details/${uuid}`, {
			timestamp,
		});
		return res.data;
	} catch (error) {
		console.log(error);
	}
}

export async function getClubs(uuids: string[]): Promise<Club[]> {
	try {
		const timestamp = Math.floor(Date.now() / 1000);
		const res = await http.get<APIResponse<Club[]>>(`/club/details/${uuids.join(",")}`, {
			timestamp,
		});
		return res.data;
	} catch (error) {
		console.log(error);
	}
}

export function loadClubWeather(uuid: string, timestamp: number) {
	return async (dispatch: Dispatch): Promise<Weather> => {
		try {
			const res = await http.get<APIResponse<{ weather: Weather }>>(`/club/weather/${uuid}/${timestamp}`);
			const weather = res.data.weather;
			dispatch({
				type: LOAD_CLUB_WEATHER,
				weather,
			});

			return weather;
		} catch (error) {
			processError(dispatch, error);
		}
	};
}

const DEFAULT_CLUB_FLOWS = "ncc,syc,cll";

export async function loadClubSlots(
	uuid: string,
	day: number,
	slotType = null,
	flows = DEFAULT_CLUB_FLOWS
): Promise<SlotsData> {
	let params = {
		day,
		flows,
	};

	if (slotType) {
		// @ts-ignore
		params = { ...params, slotType };
	}

	const slots = await getClubSlotsRequest(uuid, params);
	return slots;
}

export async function getClubSlotsRequest(uuid: string, params: {}): Promise<SlotsData> {
	const res = await http.get<APIResponse<SlotsData>>(`/slots/club/${uuid}`, params);
	return res.data;
}

export function showUnavailability({ court, slot }: { court: Court; slot: Slot }) {
	return async (dispatch: Dispatch, getState: GetState): Promise<void> => {
		dispatch({
			type: SHOW_UNAVAILABILITY,
			court,
			slot,
		});
	};
}

export async function getChampionshipInvites(
	championshipId: string,
	term?: string,
	pageCurrent: number = 0,
	pageLimit: number = 10
): Promise<APIResponse<ChampionshipInvitePayload>> {
	const params = {
		pageCurrent,
		pageLimit,
		term,
	};

	const res = await http.get<APIResponse<ChampionshipInvitePayload>>(
		`/matches/championship/${championshipId}/invites`,
		params
	);

	return res;
}

export async function addChampionshipInvite(championshipId: string, playerId: string) {
	const res = await http.post<APIResponse<{ context: ChampionshipOptInContext }>>(
		`/matches/championship/${championshipId}/invites`,
		{
			playerId,
		}
	);
}

export async function getChampionshipOptInContext(
	championshipId: string,
	voucherCode?: string,
	promotionId?: string,
	startTrial?: boolean,
	contextParams?: any[]
) {
	const params = {
		voucherCode: voucherCode,
		promotionId: promotionId,
		startTrial: startTrial,
	};

	const res = await http.get<APIResponse<{ context: ChampionshipOptInContext }>>(
		`/matches/championship/optin/${championshipId}/context`,
		params
	);
	return res.data.context;
}

export async function deleteAccount() {
	await http.delete("/auth/register");
	removeTokens();
}

export function getReservationContext({
	court = null,
	slot = null,
	preloadOnly = false,
	...reservationParams
}: {
	court?: Court;
	slot?: Slot;
	preloadOnly?: boolean;
	reservationParams?: any[];
	[x: string]: any;
}) {
	return async (dispatch: Dispatch, getState: GetState): Promise<void> => {
		const { reservation } = getState();
		let { params } = reservation;

		if (!court) {
			court = reservation.court;
		}

		params = { ...params, courtId: court ? court.courtId : null, ...reservationParams };

		if (preloadOnly) {
			dispatch({
				type: RESERVATION_CONTEXT_PRELOAD,
				reservation: {
					params,
					court,
				},
				slot,
			});

			return;
		}
		try {
			let context = await getReservationContextRequest(params);

			const durations = extractDurations(context.rules);

			if (durations.length === 0) {
				dispatch({
					type: ADD_RESERVATION_ERROR,
					errorCode: 0,
					errorText: _("reservation.noDurationsAvailable"),
				});
			} else {
				if (durations.indexOf(params.duration) === -1) {
					const duration = durations[0];
					params = { ...params, duration };
					context = await getReservationContextRequest(params);
				}

				dispatch({
					type: GET_RESERVATION_CONTEXT,
					reservation: {
						context,
						params,
						court,
					},
					slot,
				});
			}
		} catch (error) {
			processError(dispatch, error);
		}
	};
}

let reservationContextAbortController: AbortController;
export async function getReservationContextRequest(params: {}): Promise<ReservationContext> {
	if (reservationContextAbortController) {
		reservationContextAbortController.abort();
	}

	const res = await http.get<APIResponse<{ context: ReservationContext }>>("/reservation/context", params, {
		abortToken: new AbortToken(ac => {
			reservationContextAbortController = ac;
		}),
	});
	return res.data.context;
}

export function clearReservationContext() {
	return (dispatch: Dispatch, getState: GetState): void => {
		dispatch({
			type: CLEAR_RESERVATION_CONTEXT,
		});
	};
}

export function getPaymentCards(pageCurrent: number = 0, pageLimit: number = 10) {
	return async (dispatch: Dispatch, getState: GetState): Promise<void> => {
		try {
			const res = await http.get<APIResponse<Card[]>>("/payment/cards", {
				pageCurrent,
				pageLimit,
			});
			const cards = res.data;
			dispatch({
				type: LOAD_CARDS,
				cards,
			});
		} catch (error) {
			processError(dispatch, error);
		}
	};
}

export async function getChampionshipSuggestions(
	championshipId: string,
	pageCurrent: number = 0,
	pageLimit: number = 10
) {
	try {
		const res = await http.get<APIResponse<Player[]>>(`/matches/championship/${championshipId}/suggestions`, {
			pageCurrent,
			pageLimit,
		});
		return res.data;
	} catch (error) {
		console.log(error);
	}
}

export async function getChampionshipTournaments(championshipId: string): Promise<Championship[]> {
	try {
		const res = await http.get<APIResponse<Championship[]>>(`/matches/championship/${championshipId}/tournaments`);
		return res.data;
	} catch (error) {
		console.log(error);
	}
}

export async function getZendeskAuthToken(): Promise<string> {
	try {
		const res = await http.post<any>("/auth/third-party-token/zendesk");
		return res.data.jwt;
	} catch (error) {
		console.log(error);
		throw error;
	}
}

export function addCard(token: string) {
	return async (dispatch: Dispatch, getState: GetState): Promise<void> => {
		const res = await http.post<APIResponse<any>>("/payment/card", {
			token,
		});

		const { card, created } = res.data;
		if (created) {
			dispatch({
				type: ADD_CARD,
				card,
			});
		}
	};
}

export async function getSetupIntentSecret(): Promise<string | null> {
	const res = await http.post<APIResponse<any>>("/payment/card/setup");

	const { clientSecret } = res.data;
	return clientSecret;
}

export function removeCard(id: string) {
	return async (dispatch: Dispatch, getState: GetState): Promise<void> => {
		try {
			await http.delete(`/payment/card/${id}`);

			dispatch({
				type: REMOVE_CARD,
				id,
			});
		} catch (error) {
			processError(dispatch, error);
		}
	};
}

export function validateAndBook(
	stripe: Stripe,
	callback: Function,
	errorCallback: Function,
	paymentIntent = null as string
) {
	return async (dispatch: Dispatch, getState: GetState): Promise<void> => {
		await getReservationContext({})(dispatch, getState);
		let { context } = getState().reservation as ReservationState;

		await dispatch({
			type: RESERVATION_VALIDATE,
			context,
			callback: (continueBooking = false as boolean) => {
				if (continueBooking === true) {
					validateAndBook(stripe, callback, errorCallback)(dispatch, getState);
				} else {
					errorCallback();
				}
			},
		});

		const { bookingValidated } = getState().reservation as ReservationState;

		if (bookingValidated === true) {
			await makeBooking(stripe, callback, errorCallback)(dispatch, getState);
		}
	};
}

export function makeBooking(
	stripe: Stripe,
	callback: Function,
	errorCallback: Function,
	paymentIntent = null as string
) {
	return async (dispatch: Dispatch, getState: GetState): Promise<void> => {
		const state = getState().reservation as ReservationState;
		let { params, selectedCard, federationUserId, selectedNetwork } = state;

		const partners = state.partners.map(partner => {
			return {
				uuid: partner.userId || partner.playerId,
				type: partner.type,
				name: partner.firstName || partner.fullName,
				//@ts-ignore
				email: partner.type === "guest" ? partner.email : null,
			};
		});

		try {
			let data = {
				duration: params.duration,
				courtId: params.courtId,
				startDateTime: params.startDateTime,
				partners,
				paymentMethod: params.paymentMethod,
				cardId: selectedCard,
				ballMachine: params.ballMachine,
				championshipId: params.championshipId,
				voucherCode: params.voucherCode,
				paymentIntent,
				federationUserId,
				network: selectedNetwork,
			};

			if (state.edit) {
				const res = await http.put<APIResponse<{ reservation: Reservation }>>(
					`/reservation/${state.selectedReservation.reservationId}`,
					data
				);

				const reservation = res.data.reservation;
				dispatch({
					type: RESERVATION_RESULT,
					reservation,
				});

				callback(res, state.edit);
			} else {
				data = enhanceData(data);
				const res = await http.post<APIResponse<{ reservation: Reservation }>>("/reservation", data);

				fireAnalyticsEvent("ecommerce_purchase", {
					items: ["RESERVATION"],
					payment_method: data.paymentMethod,
				});

				const reservation = res.data.reservation;

				postWidgetMessage("booking_completed", {
					value: reservation.paymentDetails?.totalCost,
					currency: reservation.paymentDetails?.currency,
					reservation_id: reservation.reservationId,
					club_id: reservation.club?.clubInfo?.clubId ?? getState().club?.club?.clubInfo?.clubId,
					court_id: reservation.court?.courtId,
					start_date_time: reservation.startDateTime,
					end_date_time: reservation.endDateTime,
					payment_method: reservation.paymentDetails?.paymentMethod,
					logged_in: loggedIn(),
				});

				dispatch({
					type: RESERVATION_RESULT,
					reservation,
				});

				callback(res, state.edit);
			}
		} catch (err) {
			let errorCode = err.response.responseCode;
			let errorText = err.response.errors;

			if (err instanceof HttpError) {
				const data = await err.json<{ responseCode: string; errors }>();

				errorCode = data.responseCode;
				errorText = data.errors;
			}

			//Stripe SCA error
			if (err.response.status === 402) {
				const paymentInfo = errorText as {
					clientSecret: string;
					paymentIntent: string;
					paymentIntentId: string;
					paymentIntentStatus: string;
				};

				const { paymentIntent, error } = (await stripe.handleCardAction(
					paymentInfo.clientSecret
				)) as PaymentIntentResult;

				if (error) {
					dispatch({
						type: ADD_RESERVATION_ERROR,
						errorCode: error.code,
						errorText: error.message,
					});
				}

				if (paymentIntent) {
					await makeBooking(stripe, callback, errorCallback, paymentIntent.id)(dispatch, getState);
				}
			} else {
				if (!errorText) {
					errorText = getBookingError(errorCode);
				}

				dispatch({
					type: ADD_RESERVATION_ERROR,
					errorCode,
					errorText,
				});
			}
		} finally {
			errorCallback();
		}
	};
}

export async function cancelReservation(uuid: string): Promise<void> {
	try {
		await http.delete<APIResponse<any>>(`/reservation/${uuid}`);
	} catch (error) {
		console.log(error);
	}
}

export function selectCard(cardId: string) {
	return (dispatch: Dispatch, getState: GetState): void => {
		dispatch({
			type: SELECT_CARD,
			selectedCard: cardId,
		});
	};
}

export function selectPaymentNetwork(network: string) {
	return (dispatch: Dispatch, getState: GetState): void => {
		dispatch({
			type: SELECT_NETWORK,
			selectedNetwork: network,
		});
	};
}

export async function getReservationPartnerSuggestions(
	clubId: string,
	courtId?: string,
	startDateTime?: number
): Promise<any> {
	try {
		const res = await http.get<APIResponse<any>>("/reservation/partner/suggestions", {
			clubId,
			courtId,
			startDateTime,
		});
		const suggestions = res.data.suggestions;

		return suggestions;
	} catch (error) {
		console.log(error);
	}
}

export function addPartnerToReservation(user: User | Player, type = "player") {
	return (dispatch: Dispatch, getState: GetState): void => {
		user.type = type;
		if (user.userId !== undefined && user.playerId === undefined) {
			user.playerId = user.userId;
		} else if (user.userId === undefined && user.playerId !== undefined) {
			user.userId = user.playerId;
		}
		dispatch({
			type: ADD_PARTNER_TO_RESERVATION,
			user,
		});
	};
}

export function removePartnerFromReservation(index: number) {
	return (dispatch: Dispatch, getState: GetState): void => {
		dispatch({
			type: REMOVE_PARTNER_FROM_RESERVATION,
			index,
		});
	};
}

type SocialFindParams = {
	clubId?: string;
	term?: string;
	ageFrom?: number;
	ageTo?: number;
	gender?: string;
	skill?: string;
	longitude?: number;
	latitude?: number;
	range?: number;
	includeFavorites?: boolean;
};
export async function socialFind(
	params: SocialFindParams,
	pageCurrent: number = 0,
	pageLimit: number = 20
): Promise<SocialFindResponse> {
	try {
		const res = await http.get<SocialFindResponse>("/social/find", { ...params, pageCurrent, pageLimit });
		return res;
	} catch (error) {
		console.log(error);
		throw error;
	}
}

type PlayerProfilesParams = {
	clubId?: string;
	term?: string;
};
export async function playerProfiles(
	params: PlayerProfilesParams,
	pageCurrent: number = 0,
	pageLimit: number = 10
): Promise<APIResponse<User[]>> {
	if (playerProfilesRequestsAbortController) {
		playerProfilesRequestsAbortController.abort();
	}

	const res = await http.get<APIResponse<User[]>>(
		"/player/profiles",
		{
			...params,
			pageCurrent,
			pageLimit,
		},
		{
			abortToken: new AbortToken(ac => {
				playerProfilesRequestsAbortController = ac;
			}),
		}
	);
	return res;
}

export interface ReservationsResponse {
	reservations: Reservation[];
	pageRows: number;
	pageLimit: number;
	pageCurrent: number;
}
export type ReservationsLoader = (pageCurrent?: number, pageLimit?: number) => Promise<ReservationsResponse>;
export async function getActiveReservations(
	pageCurrent: number = 0,
	pageLimit: number = 10
): Promise<ReservationsResponse> {
	try {
		const res = await http.get<APIResponse<{ reservations: Reservation[] }>>("/reservations", {
			pageCurrent,
			pageLimit,
		});
		return {
			reservations: res.data.reservations,
			pageRows: res.pageRows,
			pageLimit: res.pageLimit,
			pageCurrent: res.pageCurrent,
		};
	} catch (error) {
		console.log(error);
		throw error;
	}
}

type Period = "last_year" | "last_6_months" | "last_3_months" | "last_month" | "this_month";
export async function getPastReservations(
	pageCurrent: number = 0,
	pageLimit: number = 10,
	period: Period = "last_year"
): Promise<ReservationsResponse> {
	try {
		const res = await http.get<APIResponse<{ reservations: Reservation[] }>>("/reservations", {
			period,
			pageCurrent,
			pageLimit,
		});
		return {
			reservations: res.data.reservations,
			pageRows: res.pageRows,
			pageLimit: res.pageLimit,
			pageCurrent: res.pageCurrent,
		};
	} catch (error) {
		console.log(error);
		throw error;
	}
}

export async function getWaitingReservations(
	pageCurrent: number = 0,
	pageLimit: number = 10
): Promise<{ waitingList: WaitingReservation[] }> {
	try {
		const res = await http.get<APIResponse<{ waitingList: WaitingReservation[] }>>("/reservation/waiting", {
			pageCurrent,
			pageLimit,
		});
		return res.data;
	} catch (error) {
		console.log(error);
		throw error;
	}
}

export async function checkWaitingReservation(uuid: string): Promise<{ onWaitingList: boolean }> {
	try {
		const res = await http.get<APIResponse<{ onWaitingList: boolean }>>(`/reservation/waiting/${uuid}`);
		return res.data;
	} catch (error) {
		console.log(error);
		throw error;
	}
}

export async function addWaitingReservation(uuid: string): Promise<{ waitingList: boolean }> {
	try {
		const res = await http.post<APIResponse<{ waitingList: boolean }>>(`/reservation/waiting/${uuid}`);
		console.log(res);
		return res.data;
	} catch (error) {
		console.log(error);
		throw error;
	}
}

export async function cancelWaitingReservation(uuid: string): Promise<{ waitingList: boolean }> {
	try {
		const res = await http.delete<APIResponse<{ waitingList: boolean }>>(`/reservation/waiting/${uuid}`);
		return res.data;
	} catch (error) {
		console.log(error);
		throw error;
	}
}

export async function getRecentClubs(): Promise<any> {
	try {
		const res = await http.get<APIResponse<any>>("/reservation/recentClubs");
		const clubs = res.data;
		if (clubs.recentClubs) {
			return clubs.recentClubs;
		}
	} catch (error) {
		console.log(error);
	}
	return [];
}

export async function getReservation(uuid: string): Promise<Reservation> {
	try {
		const res = await http.get<APIResponse<{ reservation: Reservation }>>(`/reservation/${uuid}`);
		const reservation = res.data.reservation;
		return reservation;
	} catch (error) {
		console.log(error);
		throw error;
	}
}

export async function getStreamAuthToken(): Promise<string> {
	try {
		const res = await http.get<{ data: { token: string } }>("/auth/stream/token");
		return res.data.token;
	} catch (error) {
		console.log(error);
		throw error;
	}
}

type StatsPeriod = "week" | "month" | "season" | "year";
export function getPlayerStats(
	day: number,
	sport: string = "tennis",
	period: StatsPeriod = "season",
	statname: string = "all"
) {
	return async (dispatch: Dispatch): Promise<void> => {
		try {
			const res = await http.get<APIResponse<any>>(`/player/stats/${statname}`, {
				day,
				sport,
				period,
			});
			const { stats } = res.data;
			dispatch({
				type: LOAD_SEASON_STATS,
				stats,
			});
		} catch (error) {
			console.log(error);
			//processError(dispatch, error);
		}
	};
}

export function favoriteClub(club: Club) {
	return async (dispatch: Dispatch): Promise<void> => {
		try {
			const uuid = club.clubInfo.clubId;
			dispatch({
				type: FAVORITE_CLUB,
				club,
			});
			await http.post<APIResponse<any>>(`/favorite/club/${uuid}`);
		} catch (error) {
			console.log(error);
			//processError(dispatch, error);
		}
	};
}

export function unfavoriteClub(club: Club) {
	return async (dispatch: Dispatch): Promise<void> => {
		try {
			const uuid = club.clubInfo.clubId;
			dispatch({
				type: UNFAVORITE_CLUB,
				club,
			});
			http.delete<APIResponse<any>>(`/favorite/club/${uuid}`);
		} catch (error) {
			console.log(error);
			//processError(dispatch, error);
		}
	};
}

export async function getPlayerProfile(uuid: string): Promise<Profile> {
	const res = await http.get<APIResponse<Profile>>(`/player/profile/${uuid}`);
	return res.data;
}

export async function getOfficialRating(uuid: string, federation: string, raw?: boolean): Promise<any> {
	try {
		const res = await http.get<APIResponse<any>>(
			federationBaseURL + `/federations/${federation}/${uuid}/rating${raw ? "/raw" : ""}`
		);
		return res.data;
	} catch (e) {
		flashError(_("player.officialRating.error.loadRating"));
	}
}

export async function validateLicense(
	federation: string,
	birthDate: string,
	licenseNumber: string
): Promise<{ classificationCategory }> {
	try {
		const res = await http.post<APIResponse<any>>(
			federationBaseURL + `/federations/${federation}/validate-license`,
			{
				licenseNumber: licenseNumber,
				birthDate: birthDate,
			}
		);
		flash("player.officialRating.success.validateLicense");
		return res.data;
	} catch (e) {
		flashError(_("player.officialRating.error.validateLicense"));
	}
}

export async function mapLicense(
	federation: string,
	birthDate: string,
	licenseNumber: string
): Promise<{ classificationCategory }> {
	try {
		const res = await http.post<APIResponse<any>>(federationBaseURL + `/federations/${federation}/map-license`, {
			licenseNumber: licenseNumber,
			birthDate: birthDate,
		});
		//flash("player.officialRating.success.saveLicense");
		return res.data;
	} catch (e) {
		flashError(_("player.officialRating.error.saveLicense"));
	}
}

export async function deleteLicense(federation?: string): Promise<{ classificationCategory }> {
	if (!federation) {
		return;
	}

	try {
		const res = await http.delete<APIResponse<any>>(federationBaseURL + `/federations/${federation}/map-license`);
		return res.data;
	} catch (e) {
		flashError(_("player.officialRating.error.deleteLicense"));
	}
}

export async function sendBuddyRequest(uuid: string): Promise<any> {
	try {
		const res = await http.post<APIResponse<any>>(`/social/friend/add/${uuid}`);
		return res.data;
	} catch (error) {
		return { error };
	}
}

export async function removeBuddy(uuid: string): Promise<any> {
	try {
		const res = await http.delete<APIResponse<any>>(`/social/friend/remove/${uuid}`);
		return res.data;
	} catch (error) {
		return { error };
	}
}

export function addLocation(location: Location) {
	return (dispatch: Dispatch): void => {
		try {
			dispatch({
				type: ADD_LOCATION,
				location,
			});
		} catch (error) {
			console.log(error);
			//processError(dispatch, error);
		}
	};
}

export function addLocationError(location: Location, error: PositionError) {
	return (dispatch: Dispatch): void => {
		dispatch({
			type: ADD_LOCATION_ERROR,
			location,
			error,
		});
	};
}
export function clearLocationError(location: Location) {
	return (dispatch: Dispatch): void => {
		dispatch({
			type: ADD_LOCATION_ERROR,
			location,
			error: null,
		});
	};
}

export function updateLocationPlayersCount(location: Location, playersCount: number) {
	return (dispatch: Dispatch): void => {
		dispatch({
			type: UPDATE_LOCATION_PLAYERS_COUNT,
			location,
			playersCount,
		});
	};
}

export function updateCurrentLocationCoordinates(location: Location, latitude: number, longitude: number) {
	return (dispatch: Dispatch): void => {
		dispatch({
			type: UPDATE_CURRENT_LOCATION_COORDINATES,
			location,
			latitude,
			longitude,
		});
	};
}

export function updateFavoriteClubPlayersCount(clubId: string, playersCount: number) {
	return (dispatch: Dispatch): void => {
		dispatch({
			type: UPDATE_FAVORITE_CLUB_PLAYERS_COUNT,
			clubId,
			playersCount,
		});
	};
}

export function loadAdverts() {
	return async (dispatch: Dispatch): Promise<void> => {
		try {
			const res = await http.get<APIResponse<AdData>>("/widget/content/ads");
			const adverts = res.data;

			dispatch({
				type: LOAD_ADVERTS,
				adverts,
			});
		} catch (error) {
			console.log(error);
		}
	};
}

export async function loadMatches(pageLimit: number = 10, pageCurrent: number = 1): Promise<AdData> {
	try {
		const res = await http.get<APIResponse<AdData>>("/matches", {
			pageLimit,
			pageCurrent,
		});
		return res.data;
	} catch (error) {
		console.log(error);
		//processError(dispatch, error);
	}
}

export async function confirmMatch(uuid: string): Promise<any> {
	try {
		const res = await http.post<APIResponse<any>>(`/matches/${uuid}/confirmation`);
		return res.data;
	} catch (error) {
		console.log(error);
		//processError(dispatch, error);
	}
}

export async function markMatchAsPractice(uuid: string): Promise<any> {
	try {
		const res = await http.patch<APIResponse<any>>(`/matches/${uuid}`, {
			practice: true,
		});
		return res.data;
	} catch (error) {
		console.log(error);
		//processError(dispatch, error);
	}
}

export function getMyChampionships(pageCurrent: number = 0, pageLimit: number = 10) {
	return async (dispatch: Dispatch, getState: GetState): Promise<Championship[]> => {
		try {
			const state = getState().championships;

			let championships = state.championships;

			if (state.championships === null) {
				championships = await reloadMyChampionships(pageCurrent, pageLimit)(dispatch, getState);
			}

			return championships;
		} catch (error) {
			console.log(error);
			//processError(dispatch, error);
		}
	};
}
export interface ChampionshipComparison {
	label: string;
	value: string;
	total: string;
	type: string;
	filterParameters: {
		longitude?: number;
		latitude?: number;
		clubId?: string;
	};
}
export async function getChampionshipComparisons(championshipId: string): Promise<ChampionshipComparison[]> {
	try {
		const res = await http.get<APIResponse<ChampionshipComparison[]>>(
			`/matches/championship/${championshipId}/comparisons`
		);
		return res.data;
	} catch (error) {
		console.log(error);
		throw error;
	}
}

export function reloadMyChampionships(pageCurrent: number = 0, pageLimit: number = 10) {
	return async (dispatch: Dispatch, getState: GetState): Promise<Championship[]> => {
		try {
			const res = await http.get<GetChampionshipsResponse>("/matches/my-championships", {
				pageLimit,
				pageCurrent,
			});

			//workaround for GC-357
			let championships = res.data;
			if (!Array.isArray(championships)) {
				championships = Object.values(championships);
			}

			dispatch({
				type: LOAD_MY_CHAMPIONSHIPS,
				data: championships,
			});

			return championships;
		} catch (error) {
			console.log(error);
			//processError(dispatch, error);
		}
	};
}

export function loadLeaderboardFirstPage(
	uuid: string,
	pageLimit: number = 30
): (dispatch: Dispatch) => Promise<LeaderboardData[]> {
	return async (dispatch: Dispatch): Promise<LeaderboardData[]> => {
		try {
			const { data } = await getLeaderboard(uuid, 0, pageLimit);

			dispatch({
				type: LOAD_LEADERBOARD_FIRST_PAGE,
				uuid,
				data,
			});

			return data;
		} catch (error) {
			console.log(error);
			//processError(dispatch, error);
		}
	};
}

export async function getLeaderboard(
	uuid: string,
	pageCurrent: number = 0,
	pageLimit: number = 30,
	queryParams: LeaderboardQueryParams = {}
): Promise<LeaderboardResponse> {
	try {
		return await http.get<LeaderboardResponse>(`/matches/leaderboard/${uuid}`, {
			pageLimit,
			pageCurrent,
			...queryParams,
		});
	} catch (error) {
		console.log(error);
		//processError(dispatch, error);
	}
}

export async function getChallengeLeaderboard(
	uuid: string,
	challengeId: string,
	pageCurrent: number = 0,
	pageLimit: number = 20
): Promise<LeaderboardResponse> {
	try {
		return await http.get<LeaderboardResponse>(`/matches/leaderboard/${uuid}/${challengeId}`, {
			pageLimit,
			pageCurrent,
		});
	} catch (error) {
		console.log(error);
		//processError(dispatch, error);
	}
}

export async function getMyLeaderboard(uuid: string): Promise<LeaderboardResponse> {
	try {
		return await http.get<LeaderboardResponse>(`/matches/leaderboard/${uuid}`, {
			aroundMyRank: true,
		});
	} catch (error) {
		console.log(error);
		//processError(dispatch, error);
	}
}

export function requestClubMembership(clubId: string) {
	return async (dispatch: Dispatch): Promise<any> => {
		try {
			const res = await http.post<APIResponse<any>>(`/club/${clubId}/membershiprequest`);

			dispatch({
				type: REQUEST_CLUB_MEMBERSHIP,
				clubId,
			});

			return res.data;
		} catch (error) {
			console.log(error);
			//processError(dispatch, error);
		}
	};
}

export function cancelClubMembershipRequest(uuid: string) {
	return async (dispatch: Dispatch) => {
		try {
			const res = await http.delete<APIResponse<any>>(`/club/${uuid}/membershiprequest`);

			dispatch({
				type: CANCEL_CLUB_MEMBERSHIP,
				uuid,
			});

			return res.data;
		} catch (error) {
			console.log(error);
			//processError(dispatch, error);
		}
	};
}

const myWindow: ICustomWindow = window;

export function goBackToOldApp() {
	removeNewAppForceCookie();
	removeTokens();
	//myWindow.store.dispatch({ type: UNAUTHENTICATED });
	window.location.href = process.env.REACT_APP_OLD_APP_REDIRECT_URI;
}

export function getSupportLink(profile: Profile) {
	let language = "en";
	if (profile && profile.language) {
		language = profile.language || "en";
	}

	switch (language.toLowerCase()) {
		case "de": {
			return "https://support.gotcourts.com/hc/de/categories/categories/34273891219089-Players";
		}
		case "fr": {
			return "https://support.gotcourts.com/hc/fr/categories/categories/34273891219089-Players";
		}
		default: {
			return "https://support.gotcourts.com/hc/en-gb/categories/34273891219089-Players";
		}
	}
}

export function openPlayerPopup(
	uuid: string,
	showChallengeButton = false,
	challengeButtonParams = {},
	contextParams = {}
) {
	const dispatch = myWindow.store.dispatch;
	if (!uuid) {
		return;
	}
	showPlayer(uuid, showChallengeButton, challengeButtonParams, contextParams)(dispatch, myWindow.store.getState);
}

export function openOfficialRatingPopup(uuid: string, officialRating: OfficialRating) {
	const dispatch = myWindow.store.dispatch;
	showOfficialRating(uuid, officialRating.code, officialRating.name)(dispatch, myWindow.store.getState);
}

export function openMyProfilePopup() {
	const dispatch = myWindow.store.dispatch;
	showMyProfile()(dispatch, myWindow.store.getState);
}

export function closePlayerPopup() {
	const dispatch = myWindow.store.dispatch;
	dispatch({
		type: CLOSE_PLAYER_POPUP,
	});
}

export function closeValidateProfilePopup() {
	const dispatch = myWindow.store.dispatch;
	dispatch({
		type: CLOSE_VALIDATE_PROFILE_POPUP,
	});
}

export function closeOfficialRatingPopup() {
	const dispatch = myWindow.store.dispatch;
	dispatch({
		type: CLOSE_OFFICIAL_RATING_POPUP,
	});
}

export function closeChampionshipPlayerPopup() {
	const dispatch = myWindow.store.dispatch;
	dispatch({
		type: CLOSE_PLAYER_CHAMPIONSHIP_POPUP,
	});
}

export function closeInvitePopup() {
	const dispatch = myWindow.store.dispatch;
	dispatch({
		type: CLOSE_INVITE_POPUP,
	});
}

export function closeLeaderboardPopup() {
	const dispatch = myWindow.store.dispatch;
	dispatch({
		type: CLOSE_CHAMPIONSHIP_LEADERBOARD_POPUP,
	});
}

export function closeChallengeLeaderboardPopup() {
	const dispatch = myWindow.store.dispatch;
	dispatch({
		type: CLOSE_CHALLENGE_LEADERBOARD_POPUP,
	});
}

export function loggedIn(): boolean {
	const { auth } = myWindow.store.getState();
	return auth.authenticated && hasAuthCookies() && auth.tokenExpires > Date.now();
}

export function showComparisonLeaderboardModal(
	filterParams: LeaderboardQueryParams,
	showSearchPlayer?: boolean,
	championship?: Championship,
	onPlayerSelected?: any,
	modalTitle?: string,
	backAction?: any,
	addAction?: any,
	removeAction?: any
) {
	return async (dispatch: Dispatch, getState: GetState) => {
		if (!championship) {
			return;
		}

		dispatch({
			type: OPEN_CHAMPIONSHIP_LEADERBOARD_POPUP,
			championship,
			filterParams,
			modalTitle,
			showSearchPlayer,
			onPlayerSelected,
			emptyScreenThreshold: filterParams.watchlist ? 1 : 0,
			emptyScreenInfo: filterParams.watchlist ? _("comparison.watchlist.emptyHint") : null,
			backAction,
			addAction,
			removeAction,
		});
	};
}

export function showChallengeLeaderboardModal(
	challengeId: string,
	championship?: Championship,
	onPlayerSelected?: any,
	modalTitle?: string
) {
	return async (dispatch: Dispatch, getState: GetState) => {
		if (!championship || !challengeId) {
			return;
		}

		dispatch({
			type: OPEN_CHALLENGE_LEADERBOARD_POPUP,
			championship,
			challengeId,
			modalTitle,
			onPlayerSelected,
		});
	};
}

export function showInviteModal(championship?: Championship) {
	return async (dispatch: Dispatch, getState: GetState) => {
		if (!championship) {
			return;
		}

		dispatch({
			type: OPEN_INVITE_POPUP,
			championship,
		});
	};
}

function showPlayer(uuid: string, showChallengeButton = false, challengeButtonParams = {}, contextParams = {}) {
	return async (dispatch: Dispatch, getState: GetState) => {
		try {
			const { playerModal } = getState();

			let profile = null as Profile;
			if (playerModal.profiles.hasOwnProperty(uuid)) {
				profile = playerModal.profiles[uuid];
			} else {
				profile = (await getPlayerProfile(uuid)) as Profile;
			}

			dispatch({
				type: OPEN_PLAYER_POPUP,
				uuid,
				profile,
				showChallengeButton,
				challengeButtonParams,
				contextParams,
			});
		} catch (error) {
			console.log(error);
			//processError(dispatch, error);
		}
	};
}

function showOfficialRating(uuid: string, federation: string, federationName: string) {
	return async (dispatch: Dispatch, getState: GetState) => {
		try {
			const { playerRatingModal } = getState();

			dispatch({
				type: OPEN_OFFICIAL_RATING_POPUP,
				federationName,
				uuid,
				federation,
			});
		} catch (error) {
			console.log(error);
			//processError(dispatch, error);
		}
	};
}

function showMyProfile() {
	return async (dispatch: Dispatch, getState: GetState) => {
		try {
			const { profile } = getState();

			dispatch({
				type: OPEN_PLAYER_POPUP,
				profile,
			});
		} catch (error) {
			console.log(error);
			//processError(dispatch, error);
		}
	};
}

export function showAddToChampionshipWatchListModal(championship: Championship, backAction?: any) {
	return (dispatch: Dispatch, getState: GetState) => {
		return showComparisonLeaderboardModal(
			{},
			true,
			championship,
			(player: Player, championship: Championship) => {
				return addToChampionshipWatchList(championship?.uuid, player.playerId);
			},
			_("championship.addToWatchlist.heading"),
			backAction
		)(dispatch, getState);
	};
}

export function showPlayerChampionshipProfile(
	playerId: string,
	championship: Championship,
	backAction?: any,
	infoAction?: any
) {
	return async (dispatch: Dispatch, getState: GetState) => {
		try {
			dispatch({
				type: OPEN_PLAYER_CHAMPIONSHIP_POPUP,
				championship,
				backAction,
				infoAction,
				playerId,
			});
		} catch (error) {
			console.log(error);
			//processError(dispatch, error);
		}
	};
}

export async function resendConfirmationEmail() {
	http.get("/auth/verification/email/resend");
}

export function editReservation(reservation: Reservation) {
	return async (dispatch: Dispatch, getState: GetState) => {
		dispatch({
			type: EDIT_RESERVATION,
			reservation,
		});
	};
}

export function cancelEditReservation() {
	return async (dispatch: Dispatch) => {
		dispatch({
			type: CANCEL_EDIT_RESERVATION,
		});
	};
}

export async function uploadAvatar(data: string, mediaType: string): Promise<{ error: any }> {
	try {
		const res = await http.post<APIResponse<any>>("/player/avatar", {
			profilePicture: data,
		});

		if (res.data.uploaded) {
			return { error: false };
		}

		return { error: res.responseCode };
	} catch (error) {
		return { error };
	}
}

export async function deleteAvatar(): Promise<{ error: any }> {
	try {
		await http.delete("/player/avatar");
		return { error: false };
	} catch (error) {
		return { error };
	}
}

export async function changePassword(
	currentPassword: string,
	newPassword: string,
	newPasswordConfirm: string
): Promise<{ error: any }> {
	try {
		const res = await http.post<APIResponse<any>>("/auth/changepassword", {
			old_password: currentPassword,
			new_password: newPassword,
			confirm_password: newPasswordConfirm,
		});

		if (res.data === true) {
			return { error: false };
		}

		return { error: res.responseCode };
	} catch (error) {
		return { error };
	}
}

const fireAnalyticsEvent = (eventName: string, params: any = {}) => {
	const analytics = getAnalytics();
	logEvent(analytics, eventName, params);
};

export async function joinFreeChampionship(uuid: string, startTrial: boolean = false): Promise<any> {
	const result = await http.post(`/matches/championship/optin/${uuid}`, {
		startTrial,
	});

	fireAnalyticsEvent("ecommerce_purchase", { value: 0, items: [uuid], trial: startTrial });
	return result;
}

export async function joinPaidChampionship(
	stripe: Stripe,
	uuid: string,
	card: string = null as string,
	voucherCode: string = null as string,
	promotionId: string = null as string,
	paymentMethod: string = null as string,
	network: string = null as string,
	paymentIntent: string = null as string,
	startTrial: boolean = false as boolean
): Promise<any> {
	try {
		if (!paymentMethod) paymentMethod = PaymentMethod.CreditCard;
		const result = await http.post(`/matches/championship/optin/${uuid}`, {
			card,
			paymentIntent,
			promotionId,
			voucher: voucherCode,
			paymentMethod,
			network,
			startTrial,
		});
		fireAnalyticsEvent("ecommerce_purchase", { items: [uuid], trial: false, payment_method: paymentMethod });
		return result;
	} catch (err) {
		let errorCode = err.response.responseCode;
		let errorText = err.response.errors;

		if (err instanceof HttpError) {
			const data = await err.json<{ responseCode: string; errors }>();

			errorCode = data.responseCode;
			errorText = data.errors;
		}

		//Stripe SCA error
		if (err.response.status === 402) {
			const paymentInfo = errorText as {
				clientSecret: string;
				paymentIntent: string;
				paymentIntentId: string;
				paymentIntentStatus: string;
			};

			const { paymentIntent, error } = (await stripe.handleCardAction(
				paymentInfo.clientSecret
			)) as PaymentIntentResult;

			if (error) {
				//todo
			}

			if (paymentIntent) {
				return joinPaidChampionship(
					stripe,
					uuid,
					null,
					voucherCode,
					promotionId,
					paymentMethod,
					network,
					paymentIntent.id,
					startTrial
				);
			}
		} else {
			if (!errorText) {
				errorText = getBookingError(errorCode);
			} else {
				if (Array.isArray(errorText)) {
					throw Error(errorText[0]);
				}
				throw Error(errorText);
			}
		}
	}
}

export async function loadSubscriptionPlans(): Promise<SubscriptionPlans | Error> {
	try {
		const res = await http.get<APIResponse<SubscriptionPlansData>>("/player/subscriptions");
		return res.data.plans;
	} catch (error) {
		return error;
	}
}

export async function addToChampionshipWatchList(championshipId: string, playerId: string) {
	try {
		return await http.post(`/matches/championship/${championshipId}/watchlist/${playerId}`);
	} catch (error) {
		return error;
	}
}

export async function removeFromChampionshipWatchList(championshipId: string, playerId: string) {
	try {
		return await http.delete(`/matches/championship/${championshipId}/watchlist/${playerId}`);
	} catch (error) {
		return error;
	}
}

export async function subscribeToPlan(planId: string, data: object = {}): Promise<any> {
	try {
		return await http.post(`/player/subscriptions/${planId}`, data);
	} catch (error) {
		return error;
	}
}

export async function cancelSubscriptionPlan(subscriptionId: string): Promise<any> {
	try {
		return await http.delete(`/player/subscriptions/${subscriptionId}`);
	} catch (error) {
		return error;
	}
}

export async function resubscribeToPlan(planId: string): Promise<any> {
	try {
		return await http.patch<APIResponse<any>>(`/player/subscriptions/${planId}`);
	} catch (error) {
		return error;
	}
}

export async function loadMyClubMemberships(): Promise<ClubMembershipData[]> {
	try {
		const res = await http.get<MembershipsResponse>("/player/club-memberships");
		return res.data;
	} catch (error) {
		return error;
	}
}

export async function resendPhoneVerificationCode(): Promise<any> {
	try {
		const res = await http.get<APIResponse<any>>("/auth/verification/mobile");
		return res.data;
	} catch (error) {
		return error;
	}
}

export async function verifyPhoneVerificationCode(token: string): Promise<any> {
	const res = await http.post<APIResponse<any>>("/auth/verify/mobile", {
		token,
	});
	return res.data;
}

export async function loadNewsletterSettings(): Promise<NewsletterSettings> {
	try {
		const res = await http.get<APIResponse<NewsletterData>>("/player/profile/newsletter");
		return res.data.newsletter;
	} catch (error) {
		return error;
	}
}

export async function detectCountryByIp(): Promise<void> {
	try {
		//@ts-ignore
		const { ipLocation } = window.store.getState() as RootState;

		if (!ipLocation.city) {
			const res = (await (await fetch("https://api.ipbase.com/v1/json/")).json()) as IPAPIResponse;
			setCookie("countryCode", res.country_code, 2);

			//@ts-ignore
			window.store.dispatch({
				type: IP_LOCATION_FETCHED,
				res,
			});
		}
	} catch (err) {
		console.log({ err });
	}
}

export async function getTimezoneByLocation(lat: number | string, lng: number | string): Promise<string> {
	try {
		const index = `${lat}_${lng}`;

		//@ts-ignore
		const { timezones } = window.store.getState();

		let timezone = timezones[index];
		if (!timezone) {
			const res = await http.get<APIResponse<{ timeZone: string }>>(`/widget/tz?lon=${lng}&lat=${lat}`);
			timezone = res.data.timeZone;

			// @ts-ignore
			window.store.dispatch({
				type: TIMEZONE_FETCHED,
				lat,
				lng,
				timezone,
				index,
			});
		}

		return timezone;
	} catch (err) {
		console.log({ err });
	}
}

function enhanceData(data: any) {
	const queryString = window?.location?.search || "";
	const urlParams = new URLSearchParams(queryString);

	if (!Boolean(urlParams.get("widgetMode")).valueOf()) return data;

	return {
		...data,
		// Add UTM parameters here
		utm_source: urlParams.get("utm_source"),
		utm_medium: urlParams.get("utm_medium"),
		utm_campaign: urlParams.get("utm_campaign"),
		utm_term: urlParams.get("utm_term"),
		utm_content: urlParams.get("utm_content"),
	};
}

export async function getPlaceDetails(placeId: string) {
	const res = await http.get<APIResponse<{ location: Location }>>(`/widget/place?placeId=${placeId}`);
	return res.data.location;
}
